import mermaid from 'mermaid/dist/mermaid.esm.min.mjs';

function configureMermaid() { 
    mermaid.init(undefined, ".language-mermaid");
}

if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', configureMermaid);
}
else {
    configureMermaid();
}